import { keyBy } from 'lodash'

const BUSINESS_TYPES = [
  { label: 'B2B', value: 'B2B' },
  { label: 'B2C', value: 'B2C' },
  { label: 'B2B2C', value: 'B2B2C' },
  { label: 'B2G', value: 'B2G' },
  { label: 'C2C', value: 'C2C' },
]

export function getBusinessTypes() {
  return BUSINESS_TYPES
}

export default BUSINESS_TYPES
export const businessTypeByValue = keyBy(BUSINESS_TYPES, 'value')
export const businessTypeChoices = BUSINESS_TYPES

export const getBusinessTypeLabel = (key) => {
  return businessTypeByValue[key] || ''
}
